<template>

    <section class="featured-header">
        <div class="visu-wrapper" :style="reelStyle" :class="{ p : vidPlaying }">
            <div class="vid-container">
                <video width="1680" height="944" playsinline autoplay loop muted ref="player">
                    <source type="video/mp4" :src="videoURL">
                </video>
            </div>
            <div class="pic cvr" :style="{backgroundImage: 'url('+asset.poster+')'}"></div>
        </div>
        <div class="mask" :style="maskStyle"></div>
        <div class="container n-mx">
            <div class="col infos">
                <!-- <h1 class="txt-grt-pnk">Bonding</h1> -->
                <h1 :style="{ color : Global.mockupConfig.colors.icons }">{{ asset.name }}</h1>
                <p class="desc">{{ asset.description }}</p>
                <div class="actns">

                    <div class="btn main ply sub" :style="{ background : Global.mockupConfig.colors.icons }" @click.prevent="openSubOverlay"
                        v-if="asset.planIndex != 0"
                    >
                        <span class="ico">
                            <svg width="21" height="24" viewBox="0 0 21 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z" fill="black"/>
                            </svg>
                        </span>
                        <span class="txt">Subscribe</span>
                    </div>
                    <div class="btn main ply" :style="{ background : Global.mockupConfig.colors.icons }" @click.prevent="play"
                        v-else
                    >
                        <span class="ico">
                            <svg width="21" height="24" viewBox="0 0 21 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z" fill="black"/>
                            </svg>
                        </span>
                        <span class="txt" v-if="asset.progressPerc">Resume</span>
                        <span class="txt" v-else>Play</span>
                    </div>
 
                    <div class="btn lgt inf" @click.prevent="show">
                        <span class="ico">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13ZM15 7C15 8.10457 14.1046 9 13 9C11.8954 9 11 8.10457 11 7C11 5.89543 11.8954 5 13 5C14.1046 5 15 5.89543 15 7ZM14.5 12C14.5 11.1716 13.8284 10.5 13 10.5C12.1716 10.5 11.5 11.1716 11.5 12V19C11.5 19.8284 12.1716 20.5 13 20.5C13.8284 20.5 14.5 19.8284 14.5 19V12Z" fill="white"/>
                            </svg>
                        </span>
                        <span class="txt">More info</span>
                    </div>

                </div>
            </div>
            <div class="rgt">
                <div class="sqr spn" v-if="!vidPlaying">
                    <span class="ico">
                        <svg width="29" height="29" viewBox="0 0 29 29" fill="none">
                            <path d="M2 14.5003C1.99993 11.5785 3.02338 8.749 4.89257 6.50331C6.76177 4.25762 9.35858 2.73768 12.2319 2.20752C15.1052 1.67736 18.0735 2.17049 20.621 3.60124C23.1685 5.03199 25.1344 7.30995 26.177 10.0394C27.2197 12.7688 27.2732 15.7773 26.3284 18.5421C25.3836 21.307 23.5001 23.6535 21.0051 25.174C18.5101 26.6945 15.5613 27.293 12.6709 26.8655C9.78056 26.4379 7.13128 25.0114 5.18333 22.8337" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </div>
                <div class="sqr vol" v-else @click.prevent="toggleMute" :class="{ mtd : isMuted }">
                    <span class="ico">
                        <svg width="35" height="23" viewBox="0 0 35 23" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 6.91867H3.33333C2.59733 6.91867 2 7.516 2 8.252V14.5853C2 15.3213 2.59733 15.9187 3.33333 15.9187H6.5L11.8053 20.4133C12.672 21.148 14 20.532 14 19.396V3.44133C14 2.30533 12.6707 1.68933 11.8053 2.424L6.5 6.91867Z" fill="white" stroke="white" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19.3827 16.7227C20.932 15.76 22 13.7573 22 11.4253C22 9.09333 20.932 7.08933 19.3827 6.11467" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="vol-bar"/>
                        <path d="M23.34 20.8387C25.7507 18.7653 27.3333 15.3253 27.3333 11.4227C27.3333 7.51467 25.748 4.072 23.3333 2" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="vol-bar"/>
                        <rect width="3" height="15" rx="1.5" transform="matrix(0.707103 0.70711 -0.707103 0.70711 27.8491 5.24249)" fill="white"/>
                        <rect width="3" height="15" rx="1.5" transform="matrix(0.707107 -0.707107 0.707114 0.7071 17.2427 7.36389)" fill="white"/>
                        </svg>
                    </span>
                </div>
            </div>
        </div>
    </section>

</template>

<script>

    import Global from '../lib/GlobalState'
    import { EventBus } from '../event-bus.js'

    export default {

        name: 'FeaturedHeader',

        props: {
            scroll: Number
        },

        data() {
            return {
                Global,
                vidPlaying: false,
                isMuted: true,
                videoURL: null
            }
        },

        watch: {
            asset(to) {
                this.vidPlaying = false
                this.$refs.player.pause()
                this.videoURL = to.video
                this.$refs.player.load()
                setTimeout(() => { this.launchVid() }, 2000)
            }
        },

        computed: {
            reelStyle() {
                return { transform: 'scale(' + (1 +this.scroll/(this.Global.windowHeight * 8)) + ')' }
            },
            maskStyle() {
                if (this.scroll/this.Global.windowHeight >= 1)
                    return { opacity: 1 }
                else
                    return { opacity: (this.scroll/this.Global.windowHeight) }
            },
            asset() {
                const row = this.Global.rows[0]
                const asset = this.Global.assets[row.assets[0]]
                asset.index = row.assets[0]
                return asset
            }
        },

        created() {
            EventBus.$on('closingOverlayInfo', () => { this.$refs.player.play() });
        },

        mounted() {
            this.videoURL = this.asset.video
            setTimeout(() => { this.launchVid() }, 2000)
        },

        methods: {

            launchVid() {
                if(this.$route.path !== '/preview') return
                this.$refs.player.play()
                this.vidPlaying = true
            },

            toggleMute() {
                if(this.$refs.player.muted){
                    this.$refs.player.muted = false
                    this.isMuted = false
                }else{
                    this.$refs.player.muted = true
                    this.isMuted = true
                }
            },

            // togglePlayState() {
            //     console.log(this.$refs.player.paused)
            //     if(this.$refs.player.paused)
            //         this.$refs.player.play()
            //     else
            //         this.$refs.player.pause()
            // },

            openOverlay() {
                // this.togglePlayState()
                this.$refs.player.pause()
                this.$parent.$parent.openInfoOverlay()
            },

            openSubOverlay() {
                this.Global.tempSubClosingOverlay = false
                this.Global.activeSubOverlay = true
                this.Global.activeSubInfoOverlay = true
            },

            play() {
                this.Global.assetIndexToPlay = this.asset.index
                this.$router.push("/player")
            },

            show() {
                this.Global.assetIndexToShow = this.asset.index
                this.openOverlay()
            }

        },

        beforeDestroy() {
            EventBus.$off('closingOverlayInfo');
        }

    }

</script>